"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var components_1 = require("@athena-portal/components");
var React = require("react");
var SupportPortalTemplates_1 = require("../../SupportPortalTemplates");
var services_1 = require("@falcon/services");
var LookupValue_1 = require("../../helpers/LookupValue");
var FieldDisplay_1 = require("../../components/FieldDisplay");
var Tree_1 = require("../../components/Tree");
var ClaimsTree = /** @class */ (function (_super) {
    __extends(ClaimsTree, _super);
    function ClaimsTree() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.supportPortalTemplates = new SupportPortalTemplates_1.SupportPortalTemplates;
        _this.renderPersonClaim = function (type, claim, claimNumber) {
            return ((0, jsx_runtime_1.jsx)(Tree_1.Tree, { label: (0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)("span", { className: "muli-bold-16", children: (0, jsx_runtime_1.jsx)(LookupValue_1.LookupValue, { type: type, id: claim.claimType }) }), ", ".concat(_this.supportPortalTemplates.convertDate(claim.date, "DD/MM/YYYY")), claim.claimNumber ? " (claim number: ".concat(claim.claimNumber, ")") : " (self declared)"] }) }, "claim" + claimNumber));
        };
        return _this;
    }
    ClaimsTree.prototype.render = function () {
        if (this.props.claims && this.props.claims.length > 0) {
            var personClaims = [];
            var claimNumber = 1;
            for (var _i = 0, _a = this.props.claims; _i < _a.length; _i++) {
                var claim = _a[_i];
                claim.claimTypeId = claim.claimType;
                {
                    SupportPortalTemplates_1.SupportPortalTemplates.getProductByClaim(claim) === services_1.ProductsEnum.MOTOR &&
                        personClaims.push(this.renderPersonClaim("claimType", claim, claimNumber));
                }
                {
                    SupportPortalTemplates_1.SupportPortalTemplates.getProductByClaim(claim) === services_1.ProductsEnum.RENTERS &&
                        personClaims.push(this.renderPersonClaim("rentersClaimType", claim, claimNumber));
                }
                {
                    SupportPortalTemplates_1.SupportPortalTemplates.getProductByClaim(claim) === services_1.ProductsEnum.HOME &&
                        personClaims.push(this.renderPersonClaim("homeClaimType", claim, claimNumber));
                }
                claimNumber++;
            }
            return ((0, jsx_runtime_1.jsx)(Tree_1.Tree, { label: "Claims", "data-visible": true, children: personClaims }));
        }
        else {
            return (0, jsx_runtime_1.jsx)(FieldDisplay_1.FieldDisplay, { label: "Claims", value: "None" });
        }
    };
    ClaimsTree = __decorate([
        components_1.authorize
    ], ClaimsTree);
    return ClaimsTree;
}(React.Component));
exports.default = ClaimsTree;
//# sourceMappingURL=ClaimsTree.js.map